import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../../utils/basecontext';
import { FlashMessageDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { FlashMessageProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/flashmessageprocessorfactory';
import { SubscriberValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationrequest';
import { SubscriberValidationResponse } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationresponse';
import { SubscriberValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto';
import { FlashSubscriptionDetailsRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsrequest';
import { FlashSubscriptionDetailsResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsresponse';
import { SetFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessageresponse';
import { SetFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessagerequest';
import { FlashMessageGenerateTokenRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenrequest';
import { FlashMessageGenerateTokenResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenresponse';
import { FlashMessageGenerateTokenDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/flashmessagegenereratetoken/flashmessagegeneratetoken';
import { DedicateFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/dedicate/dedicateflashmessagesresponse';

export interface SetFlashMessageAPIModel extends APIModel 
{
    validateSubscriber(subscriberValidationDto: SubscriberValidationDtoImpl): void;
    getSubscriberDetails(flashMessageDto: FlashMessageDto): void;
    setFlashMessage(flashMessageDto: FlashMessageDto): void;
    setSpecialCallerFlashMessage(flashMessageDto: FlashMessageDto): void;
}

export class SetFlashMessageAPIModelImpl extends APIModelImpl implements SetFlashMessageAPIModel 
{
    private flashMessageProcessor: FlashMessageProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.flashMessageProcessor = this.getAPIProcesssorFactory().getFlashMessageProcessorFactory();
    }

    validateSubscriber(subscriberValidationDto: SubscriberValidationDtoImpl): void 
    {
      subscriberValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());

      this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().validateSubscriber()
          .success((subscriberValidationResponse: SubscriberValidationResponse) => {
            this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
            subscriberValidationResponse.getDescription(), subscriberValidationDto.getMsisdn());
          })
          .failure((subscriberValidationResponse: SubscriberValidationResponse) => {
              this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                  subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .execute(new SubscriberValidationRequestImpl(subscriberValidationDto));
    }

    getSubscriberDetails(flashMessageDto: FlashMessageDto): void
    {
      this.flashMessageProcessor.getSubscriptionAPIProcessor()
      .success((subscriberValidationResponse: FlashSubscriptionDetailsResponse) => 
      {
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), subscriberValidationResponse.getFlashSubscriptionDetailsResponseDto());
      })
      .failure((subscriberValidationResponse: FlashSubscriptionDetailsResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashSubscriptionDetailsRequestImpl(flashMessageDto.getMsisdn()));
    }

    setFlashMessage(flashMessageDto: FlashMessageDto): void
    {
      let tokenDto = new FlashMessageGenerateTokenDtoImpl();
      tokenDto.setMsisdn(flashMessageDto.getMsisdn());
      
      this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().generateTokenProcessor()
      .success((subscriberValidationResponse1: FlashMessageGenerateTokenResponse) => 
      {
            this.flashMessageProcessor.setFlashMessageAPIProcessor()
            .success((subscriberValidationResponse: SetFlashMessageResponse) => {
              this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
            })
            .failure((subscriberValidationResponse: SetFlashMessageResponse) => {
                this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                subscriberValidationResponse.getDescription(), subscriberValidationResponse1);
            })
            .execute(new SetFlashMessageRequestImpl(flashMessageDto));
      })
      .failure((subscriberValidationResponse: FlashMessageGenerateTokenResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashMessageGenerateTokenRequestImpl(tokenDto));
     
    }

    setSpecialCallerFlashMessage(flashMessageDto: FlashMessageDto): void
    {
      let tokenDto = new FlashMessageGenerateTokenDtoImpl();
      tokenDto.setMsisdn(flashMessageDto.getMsisdn());
      
      this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().generateTokenProcessor()
      .success((subscriberValidationResponse1: FlashMessageGenerateTokenResponse) => 
      {
            this.flashMessageProcessor.getDedicateFlashAPIProcessor()
            .success((subscriberValidationResponse: DedicateFlashMessageResponse) => {
              this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
            })
            .failure((subscriberValidationResponse: DedicateFlashMessageResponse) => {
                this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                subscriberValidationResponse.getDescription(), subscriberValidationResponse1);
            })
            .execute(new SetFlashMessageRequestImpl(flashMessageDto));
      })
      .failure((subscriberValidationResponse: FlashMessageGenerateTokenResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashMessageGenerateTokenRequestImpl(tokenDto));
     
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/setflashmessage/setflashmessageapimodel.tsx